import type { FaireProductEntity } from "../../entity_types/product";

export const p_qm4vz665v4: FaireProductEntity = {
  token: "p_qm4vz665v4",
  type: "product",
  name: "Vintage Cola",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/f7e34cb540701b9db0f83efe21f7388849d09a3d1f0251983b4ebf3e789f7784.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de834a288e6dd9a6a1c804bf48f23153008546b781a02dc6b63f6820477679c7.png",
    "https://cdn.faire.com/fastly/dc3b60ad7b1b2639d9976d36ccebfad14ec9324d445dce15e8923372d0ea80c3.png",
    "https://cdn.faire.com/fastly/5ba9a86bbb10774cac716cbb4a52703197074aa3b30bd76219d807f350ecf711.png",
    "https://cdn.faire.com/fastly/9e2bbfd46bba086cefc270a19ae3fe9cec849048a1c9c8633ce946c6884ea2d4.png",
    "https://cdn.faire.com/fastly/a7f55e868a7b920efbc3fcedf8ad6fef5426466dd0c29a79991be6be3881cbdc.png",
  ],
  priceDollars: 28.99,
  description:
    "Our small batch prebiotic Cola has the same old-fashioned taste you grew up loving but is naturally enhanced with distinct notes of vanilla, cinnamon and caramel. It strikes a delicate and delicious balance between healthy and crave-able.\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:08.431Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
